import * as React from "react";
import { UserMessagePage } from "./userMessageTypes";
import Button from "@material-ui/core/Button";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Dialog from "material-ui/Dialog";
import handleMutationError from "app/utils/handleMutationError";

type Props = {
  page: UserMessagePage;
  userMessageId: number;
  close: Function;
  deleteUserMessagePage?: any;
  data?: any;
};

type State = {
  deleting: boolean;
};

class DeletePageModal extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      deleting: false
    };
  }

  onDelete = (): void => {
    this.setState({ deleting: true });
    this.props
      .deleteUserMessagePage({
        variables: {
          user_message_id: this.props.userMessageId,
          id: this.props.page.id
        }
      })
      .then(e => {
        this.props.close({ refetchData: true });
      })
      .catch(error => {
        handleMutationError(error);
      })
      .finally(() => this.setState({ deleting: false }));
  };

  render() {
    return (
      <Dialog
        title="Delete Page"
        modal={false}
        open={this.props.page != null}
        actions={[
          <Button color="secondary" onClick={() => this.props.close()}>
            No
          </Button>,
          <Button
            disabled={this.state.deleting}
            color="primary"
            onClick={this.onDelete}
          >
            {this.state.deleting ? "Deleting..." : "Yes"}
          </Button>
        ]}
        onRequestClose={this.props.close}
      />
    );
  }
}

const deleteUserMessagePage = graphql<Props, any, any>(
  gql`
    mutation deleteUserMessagePage($user_message_id: ID!, $id: ID!) {
      delete_user_message_page(user_message_id: $user_message_id, id: $id) {
        id
      }
    }
  `,
  { name: "deleteUserMessagePage" }
);

export default compose(deleteUserMessagePage)(DeletePageModal);
